import React from "react";

const WhyChooseUs = () => {
  const features = [
    {
      id: 1,
      title: "Premium Cars",
      description: "Drive in style with our top-tier vehicle selection",
      svg: (
        <svg
          width="42"
          height="43"
          viewBox="0 0 42 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_292_293)">
            <path
              d="M41.3588 17.495C41.6588 17.095 41.6588 16.595 41.3588 16.195L34.2588 8.19502C34.0588 7.99502 33.7588 7.89502 33.5588 7.89502H8.65879C8.45879 7.89502 8.05879 8.09502 7.95879 8.19502L0.858789 16.195C0.558789 16.495 0.558789 17.095 0.858789 17.495L20.3588 42.195C20.7588 42.795 21.5588 42.695 21.9588 42.195L41.3588 17.495ZM21.0588 10.295L26.3588 15.895H15.7588L21.0588 10.295ZM13.6588 15.295L10.4588 9.89502H18.7588L13.6588 15.295ZM23.3588 9.89502H31.6588L28.4588 15.295L23.3588 9.89502ZM27.3588 17.895L21.0588 38.295L14.7588 17.895H27.3588ZM29.4588 17.895H38.5588L23.5588 36.895L29.4588 17.895ZM30.4588 15.895L33.6588 10.495L38.3588 15.895H30.4588ZM8.45879 10.595L11.6588 15.995H3.75879L8.45879 10.595ZM12.6588 17.895L18.4588 36.895L3.55879 17.895H12.6588Z"
              fill="white"
            />
            <path
              d="M12.5586 5.99497C12.9586 6.39497 13.5586 6.39497 13.9586 5.99497C14.3586 5.59497 14.3586 4.99497 13.9586 4.59497L10.7586 1.39497C10.3586 0.994971 9.75859 0.994971 9.35859 1.39497C8.95859 1.79497 8.95859 2.39497 9.35859 2.79497L12.5586 5.99497Z"
              fill="white"
            />
            <path
              d="M29.5594 5.99497L32.7594 2.79497C33.1594 2.39497 33.1594 1.79497 32.7594 1.39497C32.3594 0.994971 31.7594 0.994971 31.3594 1.39497L28.1594 4.59497C27.7594 4.99497 27.7594 5.59497 28.1594 5.99497C28.5594 6.39497 29.1594 6.39497 29.5594 5.99497Z"
              fill="white"
            />
            <path
              d="M21.0586 6.29502C21.6586 6.29502 22.0586 5.89502 22.0586 5.29502V1.39502C22.0586 0.79502 21.6586 0.39502 21.0586 0.39502C20.4586 0.39502 20.0586 0.79502 20.0586 1.39502V5.29502C20.0586 5.79502 20.4586 6.29502 21.0586 6.29502Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_292_293">
              <rect
                width="40.95"
                height="42.21"
                fill="white"
                transform="translate(0.628906 0.39502)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      id: 2,
      title: "The Car You Need",
      description: "Reliable and Affordable Rental Options",
      svg: (
        <svg
          width="61"
          height="61"
          viewBox="0 0 61 61"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_292_303"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="61"
            height="61"
          >
            <rect
              x="0.103516"
              y="0.5"
              width="60"
              height="60"
              fill="url(#pattern0_292_303)"
            />
          </mask>
          <g mask="url(#mask0_292_303)">
            <rect x="-18" y="5" width="85.1562" height="68.3594" fill="white" />
          </g>
          <defs>
            <pattern
              id="pattern0_292_303"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_292_303" transform="scale(0.0078125)" />
            </pattern>
            <image
              id="image0_292_303"
              width="128"
              height="128"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      ),
    },
    {
      id: 3,
      title: "Customer Services",
      description: "We are here to assist you every step of the way",
      svg: (
        <svg
          width="46"
          height="45"
          viewBox="0 0 46 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_292_314"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="46"
            height="45"
          >
            <rect
              x="20.6025"
              y="0.319946"
              width="25"
              height="25"
              fill="url(#pattern0_292_314)"
            />
            <path
              d="M32.5764 11.5519L32.3524 10.4479C32.5391 10.3999 32.7097 10.3466 32.8644 10.2879C33.0244 10.2293 33.1631 10.1653 33.2804 10.0959C33.3977 10.0213 33.4964 9.94128 33.5764 9.85595C33.6617 9.77061 33.7231 9.67728 33.7604 9.57595C33.8031 9.47461 33.8244 9.36795 33.8244 9.25595C33.8244 9.11728 33.7897 8.99461 33.7204 8.88795C33.6511 8.78128 33.5524 8.69861 33.4244 8.63995C33.2964 8.58128 33.1551 8.55195 33.0004 8.55195C32.7977 8.55195 32.6004 8.62128 32.4084 8.75995C32.2164 8.89861 32.0484 9.10395 31.9044 9.37595L31.2084 8.75995C31.4377 8.40261 31.7124 8.12528 32.0324 7.92795C32.3577 7.73061 32.6991 7.63195 33.0564 7.63195C33.3977 7.63195 33.7044 7.70128 33.9764 7.83995C34.2484 7.97861 34.4644 8.17061 34.6244 8.41595C34.7844 8.65595 34.8644 8.92795 34.8644 9.23195C34.8644 9.41328 34.8271 9.59461 34.7524 9.77595C34.6777 9.95195 34.5711 10.1173 34.4324 10.2719C34.2937 10.4266 34.1311 10.5653 33.9444 10.6879C33.7577 10.8053 33.5524 10.9013 33.3284 10.9759L33.2164 11.5519H32.5764ZM32.2884 12.7679C32.2884 12.5813 32.3444 12.4293 32.4564 12.3119C32.5684 12.1893 32.7151 12.1279 32.8964 12.1279C33.0831 12.1279 33.2297 12.1839 33.3364 12.2959C33.4431 12.4026 33.4964 12.5599 33.4964 12.7679C33.4964 12.9546 33.4404 13.1093 33.3284 13.2319C33.2164 13.3493 33.0724 13.4079 32.8964 13.4079C32.7044 13.4079 32.5551 13.3519 32.4484 13.2399C32.3417 13.1279 32.2884 12.9706 32.2884 12.7679Z"
              fill="white"
            />
            <path
              d="M15.6828 26.9999C20.5628 26.9999 24.5228 23.0399 24.5228 18.1599C24.5228 13.2799 20.5628 9.31995 15.6828 9.31995C10.8028 9.31995 6.84277 13.2799 6.84277 18.1599C6.84277 23.0399 10.8028 26.9999 15.6828 26.9999ZM15.6828 11.8399C19.1728 11.8399 21.9928 14.6699 21.9928 18.1499C21.9928 21.6299 19.1628 24.4599 15.6828 24.4599C12.2028 24.4599 9.37277 21.6299 9.37277 18.1499C9.37277 14.6699 12.2028 11.8399 15.6828 11.8399Z"
              fill="black"
            />
            <path
              d="M16.9424 29.5299H14.4124C7.3024 29.5299 1.4324 34.8699 0.622398 41.7699C0.442398 43.3199 1.6424 44.6799 3.1924 44.6799H28.1624C29.7224 44.6799 30.9224 43.3099 30.7324 41.7699C29.9124 34.8699 24.0524 29.5299 16.9324 29.5299H16.9424ZM6.5324 42.1599C4.6324 42.1599 3.3624 40.1699 4.1924 38.4499C6.0424 34.6399 9.9524 32.0499 14.4124 32.0499H16.9424C21.4024 32.0499 25.3124 34.6299 27.1624 38.4499C27.9924 40.1599 26.7324 42.1599 24.8224 42.1599C20.0224 42.1599 11.3224 42.1599 6.5324 42.1599Z"
              fill="black"
            />
          </mask>
          <g mask="url(#mask0_292_314)">
            <rect
              x="-17.3975"
              y="-1.68005"
              width="85.1562"
              height="68.3594"
              fill="white"
            />
          </g>
          <defs>
            <pattern
              id="pattern0_292_314"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_292_314" transform="scale(0.0078125)" />
            </pattern>
            <image
              id="image0_292_314"
              width="128"
              height="128"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAEYElEQVR4nO3dO4gdZRjG8f8bJYiKmCCCEixEJUjEiAniBUQQL4VgIyEiCuIWaUQLSWFlJ6JVLFLYBMFbYUQs1EJB8FIoiRokqMTKECXuJqJhCWEfi9kDEjbJnsN+3zcz7/ODUyVz3o+ZP2fmzO6eE5KwvNa1XoC15QCScwDJOYDkHEByDiA5B5CcA0jOASTnAJJzAMk5gOQcQHIOIDkHkJwDSM4BJOcAknMAyTmA5BxAcg4gOQeQ3MU1h0XEeuBxYCdwE3Blzfk9dgI4DLwNvCXpTK3BUesPQyJiC/AucHOVgcP1A/CYpJ9rDKsSwPLB/xK4oviwcZgH7qwRQfEAIuIS4ACwueig8TkIbC99OqhxEfgMPviz2Ao8UXpIjQB2VpgxVjtKD6hxCvgXuLTokPE6JumakgNqBOC/P5/dkqSLSg6oeh/gHDa0XkBjC+f5t+Kn6OavAJKi6AJ6rvX+8a3g5BxAcg4gOQeQnANIzgEk5wCScwDJOYDkHEByDiA5B5CcA0jOASTnAJJzAMk5gOQcQHIOIDkHkJwDSM4BJOcAknMAyTmA5BxAcg4gOQeQnANIzgEk5wCScwDJOYDkHEByDiA5B5CcA0jOASTX/HMCI+K3GTb7G3he0mdrMP97En+K+ZA/KnYJeB3YLWlx1ieJiAX6+8UVpyRdVnJAjVPA4ULPuw54FjgQEdsKzWjtUOkBNQLYX/j5NwNfR8RLEdH8lLbGSu+7KqeAjcAvwMaigzrfAk9J+mm1G/T4FHAcuFHSiZJDir8CSJoH5ujO2aVtA76LiOciYsjvcM7QhVz04AMgqcoDeBQ4CajS43PgulWsa6Himlbz+At4qNpxqTVoeWdvAvYAf1TamSeBpwcSwO/Aa8DVNY9Jta+NO1tEXAusn3KzB+h20uVTbvchMCfpzxXWcaFrgFvp7juUtCjpWOEZK2oWwKwi4npgH3DPlJsep4vgg7Oe70IBbKhyLm5kcBdKko4A9wK7gdNTbHoVsD8i9kVEH6/6mxhcAACSliS9AtxO9/1603gS+DEi7l/7lQ3PIAOYkHQIuAN4me6t02ptAj6JiD304OchLQ3uGuBcIuIuumuDG9b4qX0NMASSvgJuA/a2XsuQjCYAAEn/SNoFPAwcbb2eIRhVABOSPgZuAd5rvZa+G2UA0P0MQtIOuu8unm+9nr4abQATkt6hezX4tPVa+mj0AQBIOirpQWAXcKr1evokRQATkvbS3dv/pvVa+iJVAACSfgXuBl5kulvJozSaG0GziIitwJvAlvP8N98IGitJB4HtwKvU+Y2l3kkdAICkRUkvAPcBR1qvp7b0AUxI+oLuAvGN1mupyQH8z/Kt5DngEaDJb+jU5gBWIOkjuptH77deS2mp3wWYXwHScwDJOYDkHEByDiA5B5CcA0jOASTnAJJzAMk5gOQcQHIOIDkHkJwDSM4BJOcAknMAyTmA5BxAcg4gOQeQnANIzgEk5wCScwDJOYDk/gPuQv9Yu35vfQAAAABJRU5ErkJggg=="
            />
          </defs>
        </svg>
      ),
    },
    {
      id: 4,
      title: "Door-to-Door Delivery",
      description: "Convenient delivery and pickup at your door step",
      svg: (
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <mask
            id="mask0_292_324"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="51"
            height="51"
          >
            <rect
              x="0.103516"
              y="0.5"
              width="50"
              height="50"
              fill="url(#pattern0_292_324)"
            />
          </mask>
          <g mask="url(#mask0_292_324)">
            <rect
              x="-18"
              y="-3"
              width="85.1562"
              height="68.3594"
              fill="white"
            />
          </g>
          <defs>
            <pattern
              id="pattern0_292_324"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_292_324" transform="scale(0.0078125)" />
            </pattern>
            <image
              id="image0_292_324"
              width="128"
              height="128"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      ),
    },
  ];

  return (
    <section className="py-16 bg-[#1675D3]">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex justify-center my-2">
          <h2 className="text-4xl font-bold text-center text-#1212120">
            Our Services
          </h2>
        </div>
        <div className="flex justify-center mb-12 max-w-2xl mx-auto my-2">
          <span className="text-white text-center text-md">
            At Blue Diamond Enterprise, we offer a wide range of high-quality
            services designed to meet your transportation needs. Our team of
            dedicated professionals is committed to providing you with
            exceptional service and unparalleled expertise.
          </span>
        </div>
        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="text-center space-y-4 border border-black rounded-lg px-4 py-12"
            >
              {/* Circle with Number */}

              <div className="flex items-center justify-center text-lg font-bold w-full">
                {feature.svg}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-[#F5F5F7]">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-[#F5F5F7] text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
